module.exports = __webpack_public_path__ + "img/bgphone.887ebcee.png";